import type { SearchableProduct } from "./types"

interface ProductFields {
  name: string
  short_name: string
  sku: string
  code: string
  labels: string[]
}

/** Lowercased-once view of a product's searchable fields. */
export function extractFields(product: SearchableProduct): ProductFields {
  return {
    name: (product.name ?? "").toLowerCase(),
    short_name: (product.short_name ?? "").toLowerCase(),
    sku: (product.sku ?? "").toLowerCase(),
    code: (product.code ?? "").toLowerCase(),
    labels: (product.labels ?? [])
      .map((l) => l?.name?.toLowerCase() ?? "")
      .filter((s): s is string => Boolean(s)),
  }
}

/** True if any searchable field contains any of the given exclude substrings. */
export function matchesAnyExclude(
  fields: ProductFields,
  excludes: string[]
): boolean {
  if (excludes.length === 0) return false
  for (const ex of excludes) {
    const e = ex.toLowerCase()
    if (!e) continue
    if (
      fields.name.includes(e) ||
      fields.sku.includes(e) ||
      fields.short_name.includes(e) ||
      fields.code.includes(e) ||
      fields.labels.some((l) => l.includes(e))
    ) {
      return true
    }
  }
  return false
}
